<template>
    <div class="clearfix userCenterView">
        <orderDetal ref="detail"/>
        <RefundModal ref="refund" />
        <Delivery ref="send" @success="refreshPage"/>
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="pr orderWrap">
                <el-row class="demo-autocomplete">
                    <el-col :span="12">
                        <el-autocomplete
                        style="width: 475px;border-raiuds: 0;height: 32px;"
                        class="inline-input"
                        v-model="state2"
                        :fetch-suggestions="querySearch"
                        :placeholder="'输入商品名称或者订单号查询'"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        >
                        </el-autocomplete>
                    </el-col>
                </el-row>
                <div class="serarchButton" @click="search()"></div>
                <NavMenu ref="menu" :prop="tabsData" class="mt30" @func="getMsg"/> 
                <div class="contentTitle mt20">
                    <div class="w275">商品信息</div>
                    <div class="w80">单价</div>
                    <div class="w80">数量</div>
                    <div class="w80">支付类型</div>
                    <div class="w80">实付金额</div>
                    <div class="w156">订单状态</div>
                    <div class="w156">操作</div>
                </div>
                <div class="orderListContainer">
                    <div class="orderList" v-for="(item,index) in list" :key="index">
                        <div class="contentTitle mt20 pl20" >
                            <span>{{item.add_time}}</span>
                            <span class="ml20">订单号: {{ item.order_sn }}</span>
                        </div>
                        <div class="orderListBody">
                            <div v-for="(itemSub,i) in item.order_goods" :key="i" class="orderInfo">
                                <div class="imgBox" @click="toDetail(itemSub)"><img :src="spliceImg(itemSub.original_img)" /></div>
                                <div class="info">
                                    <div class="name">{{ itemSub.goods_name}} </div>
                                    <div class="specifications">{{ itemSub.goods_spec }}</div>
                                </div>
                                <div class="price w80 tc colorRed">￥ {{ itemSub.market_price }}</div>
                                <div class="amount tc w80">{{ itemSub.goods_num }}</div>
                            </div>
                            <div class="state tc">
                                <div class="orderState">
                                    <div class="sum w80 tc">{{item.pay_type === 0 ? '普通支付' : '预支付'}}</div>
                                    <div class="sum w80 tc colorRed">￥{{item.order_amount}}</div>
                                    <div class="csd w156">{{ orderStatus.get(item.order_status) }}{{item.order_status === 0 && item.pay_type === 0 ? `(${item.countdownTimeStr})` : ''}}</div>
                                    <div class="operate w156">
                                        <div class="csp" @click="openDetail(item)">订单详情</div>
                                        <div class="csp" @click="toPayment(item)" v-if="item.order_status === 0 && item.pay_type === 0">付款</div>
                                        <div v-if="item.order_status === 0" @click="cancelOrder(item)">取消订单</div>
                                        <div v-if="item.order_status === 2">已付款，等待发货..</div>
                                        <div v-if="item.order_status === 2 && item.pay_type === 0" @click="justMoneyRefund(item)">仅退款</div>
                                        <div v-if="item.order_status === 6">退货中..</div>
                                        <div v-if="item.order_status === 4 && item.pay_type === 0" @click="refund(item)">退款</div>
                                        <div v-if="item.order_status === 3" @click="confirmOrder(item)">确认收货</div>
                                        <div v-if="item.order_status === 3" class="csp" @click="gotoLogistics(item)">查看物流</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="queryOption.page"
                        :page-size="10"
                        layout="prev, pager, next, jumper"
                        :total="totalRow">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import NavMenu from '@/components/navMenu/underline.vue'
import { OrderService } from '../../../service/order.service'
import { formatDateDate } from '@/utils/formatDate.js'
import orderDetal from './orderDetail.vue';
import RefundModal from './refundOrder.vue';
import Delivery from './delivery.vue';
import { MessageBox } from 'element-ui'
import moment from 'moment'

const orderStatus = new Map([
    [0, '未付款'],
    [2, '已付款'],
    [3, '发货中'],
    [4, '订单完成'],
    [6, '退货中'],
    [7, '退款中'],
    [8, '退款完成'],
    [9, '付款中'],
    [-1, '订单关闭/订单过期'],
]);

const tabsData = [
    { title: '全部', key: 10 },
    { title: '待付款', key: 0, num: 0 },
    { title: '待发货', key: 2, num: 0 },
    { title: '已发货', key: 3, num: 0 },
    { title: '订单完成', key: 4, num: 0 },
    { title: '退款', key: 7, num: 0 },
    { title: '过期或关闭订单', key: -1, num: 0 },
];
export default {
    data() {
        return {
            orderStatus,
            tabsData,
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '我的订单',
                path: '/userCenter/order'
            }],
            commdity: [],
            state2: '',
            list: [],
            queryOption: {
                page: 1,
                page_size: 20,
            },
            totalRow: 0,
            tabsKey: 10,
            downCountTimer: null,
        }
    },
    filters: {
        formatDate: formatDateDate
    },
    components: {Bread, NavMenu, orderDetal, RefundModal, Delivery},
    created() {
        this.downCountTimer = setInterval(() => {
            this.list.forEach(item => {
                const diffminute = moment().diff(moment(item.add_time), 'seconds');
                if (diffminute > (15 * 60)) {
                    item.countdownTimeStr = '已过期';
                } else {
                    item.countdownTimeStr = moment(0).seconds((15 * 60) - diffminute.valueOf()).format('mm:ss');
                }
            });
            this.list = [...this.list];
        }, 1000);
        this.getList({ order_status: 10, page: 1 }).then(()=>{
            if(this.$route.query.page){
                this.$refs.menu.handleSelect(this.$route.query.page)
            }
        });
    },
    destroyed() {
        clearInterval(this.downCountTimer);
    },
    methods: {
        async getList(fields) {
            const query = { ...this.queryOption, ...fields }
            const data = await OrderService.getList(query);
            this.list = data.list;
            this.queryOption = {
                ...fields,
                page: +data.page,
                page_size: 10,
            };
            this.totalRow = data.totalRow;
            this.tabsData.forEach(item => {
                item.num = (data.status_num[item.key] || {}).num;
            });
            this.tabsData = [...this.tabsData];
        },
        spliceImg(imgStr = '') {
            const url = 'https://api.goodyiyao.cn/';
            // const url2 = 'http://api.goodyiyao.cn/';
            // return url + imgStr.replace(imgStr.match(/^[http|https]/) ? url : url2, '');
            return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
        },
        querySearch(queryString, cb) {
            var commdity = this.commdity;
            var results = queryString ? commdity.filter(this.createFilter(queryString)) : commdity;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            this.getList({ order_status: item.key, page: 1 });
        },
        handleCurrentChange(value) {
            this.getList({ page: value });
        },
        search() {
            this.getList({ search: this.state2, order_status: this.tabsKey, page: 1  })
        },
        loadAll() {
            return [
                { "value": "三全鲜食（北新泾店）"},
                { "value": "Hot honey 首尔炸鸡（仙霞路）"},
            ]
        },
        async justMoneyRefund(item) {
            const { value } = await MessageBox.prompt('确定要退款？仅退回付款金额(请输入退款原因)');
            await OrderService.orderRefund(item.order_sn, 0, value);
            this.refreshPage();
        },
        async refund(item) {
            // await MessageBox.confirm('确定退货退款？');
            this.$refs.send.open(item);
            // await OrderService.orderRefund(item.order_sn, 1);
            // this.refreshPage();
        },
        openDetail(item) {
            this.$refs.detail.open(item);
        },
        async confirmOrder(item) {
            await MessageBox.confirm('确定已经收到货了吗？');
            await OrderService.confirmOrder(item.order_sn);
            this.$message.success('操作成功！');
            this.refreshPage();
        },
        refreshPage() {
            this.getList({ search: this.state2, order_status: this.tabsKey })
        },
        getMsg(data) {
            this.tabsKey = data.key;
            this.getList({ order_status: data.key, page: 1 });
        },
        gotoLogistics(item) {
            this.$router.push(`/userCenter/logistics?order_sn=${item.order_sn}`);
        },
        toPayment(item) {
            window.open(location.origin + location.pathname + '#/order/order?order_sn=' + item.order_sn);
        },
        toDetail(item) {
            this.$router.push('/goodDetail/' + item.goods_id);
        },
        async cancelOrder(item) {
            await MessageBox.confirm('确定要取消订单吗？');
            await OrderService.cancelOrder(item.order_sn);
            this.refreshPage();
        },
    },
    mounted() {6
        this.commdity = this.loadAll();
    }
}
</script>
<style lang="scss" scoped>
    .orderWrap{
        padding: 15px;
        border: 1px solid #e3e2e1;
        .demo-autocomplete.el-row{
            margin: 0;
            position: relative;
            left: 0;
        }
        .serarchButton{
            position: absolute;
            width: 70px;
            height: 35px;
            background: url('../../../assets/images/icon/searchIcon.png') center center no-repeat #1d90d0;
            left: 420px;
            top: 15px;
            cursor: pointer;
        }
        .contentTitle{
            display: flex;
            text-indent: 0;
            > div{
                text-align: center;
            }
        }
        .orderInfo{
            display: flex;
            padding: 8px;
            width: 427px;
            font-size: 15px;
            border: 1px solid #e3e2e1;
            border-top: none;
            .imgBox{
                margin-right: 15px;
                cursor: pointer;
                img{
                    width: 108px;
                    height: 86px;
                }
            }
            .info{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 15px 0;
                width: 143px;
            }
            .price,.amount,.sum{
                line-height: 80px;
            }
            .state{
                display: flex;
                justify-content: space-between;
                padding: 8px 0;
            }
        }
    }
    .orderListBody {
        display: table;
        width: 100%;
        .state {
            display: table-cell;
            vertical-align: middle;
            border-right: 1px solid #e3e2e1;
            border-bottom: 1px solid #e3e2e1;
        }
    }
    .orderListContainer {
        
    }
    .pagination {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
    }
    .orderState {
        display: flex;
        width: 456px;
        box-sizing: border-box;
        justify-content: space-between;
    }
    .operate > div {
        cursor: pointer;
    }
    .userCenter{
        .contentTitle{
            border: 1px solid #e3e2e1;
        }
    }
</style>
<style lang="scss">
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 0 50px 30px;
            border: 1px solid #e3e2e1;
            
        }
    }
    .p-user-data{
        display: flex;
        align-items: center;
        
    }
    .contentItem{
        display: flex;
        margin-top: 15px;
        label{
            width: 80px;
            line-height: 35px;
        }
        .el-input__inner{
            width: 300px;
            height: 35px;
            line-height: 35px;
        }
        
    }
</style>
